

import firebase from "../firebase";
import UtilService from "@/services/UtilService";
const settings = firebase.ref("/settings");

class SettingsService {
  getAll() {
    return settings.orderByChild("IsDeleted").equalTo(0);
  }
  
  getById(Id) {
    var ref = settings.child('/'+Id);
    return ref;
  }

  getByName(Name){
    return settings.orderByChild("Name").equalTo(Name);
  }

  create(lead) {
    return leads.orderByChild("CompanyName").equalTo(lead["CompanyName"]).once("value", snapshot => {
        if (snapshot.exists()){
          return null;
        } else {
            var newPostRef = leads.push();
            var Id = newPostRef.key;
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            lead['Id'] = Id;
            lead["CreatedDate"] = lead["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);

            return leads.child(Id).set(lead);
        }
    });
  }

  create(setting) {
    return settings.orderByChild("Name").equalTo(setting["Name"]).once('value', snapshot => {
        let isExists = false;
        if(snapshot.exists() && snapshot.val()){
          var key = Object.keys(snapshot.val())[0];
          let data = {...snapshot.val()}
          if(data && data[key] && data[key]['Name'] && setting['Name']){
            const Name = data[key]['Name'].trim();
            const CurrentName = setting['Name'].trim();
            isExists = (Name.toLowerCase() === CurrentName.toLowerCase());
          }
        }
        if (isExists){
          return null;
        } else {
          var newPostRef = settings.push();
          var Id = newPostRef.key;
          const userInfo = JSON.parse(localStorage.getItem("userInfo"));
          setting['Id'] = Id;
          setting["CreatedDate"] = setting["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);

          return settings.child(Id).set(setting);
        }
    });
  }

  update(key, setting) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    setting["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);
    return settings.child(key).update(setting);
  }

  delete(key) { 
    return settings.child(key).update({ 
    IsDeleted: 1
   });
  }

  deleteAll() {
    return settings.remove();
  }
}

export default new SettingsService();
